class DetailComponent extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
  }

  connectedCallback() {
    const content = this.querySelector('.detail-content');

    // Se tem atributo 'closed', começa fechado
    if (this.hasAttribute('closed') || (content && content.hasAttribute('closed'))) {
      this.isOpen = false;
    } else {
      this.isOpen = true;
      this.classList.add('is-open');
    }

    this.setupComponent();
  }

  setupComponent() {
    const headings = this.querySelector('.detail-headings');

    if (headings) {
      headings.style.cursor = 'pointer';
      headings.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleDetail();
      });
    }
  }

  toggleDetail() {
    const content = this.querySelector('.detail-content');

    if (!content) return;

    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      // Abrir
      this.classList.add('is-open');
      this.removeAttribute('closed');
      content.removeAttribute('closed');
      content.style.display = 'block';
      content.style.visibility = 'visible';
      content.style.opacity = '1';
    } else {
      // Fechar
      this.classList.remove('is-open');
      this.setAttribute('closed', '');
      content.setAttribute('closed', '');
      content.style.display = 'none';
      content.style.visibility = 'hidden';
      content.style.opacity = '0';
    }
  }
}

customElements.define('detail-component', DetailComponent);